import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/utils';

type ScoringExamplesProps = {
  score1: string;
  score3: string;
  score5: string;
};

export function ScoringExamplesPanel({
  score1,
  score3,
  score5
}: ScoringExamplesProps): React.ReactNode {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={() => {
          setOpen((v) => !v);
        }}
        className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ChevronDown className={cn('size-3 transition-transform', open && 'rotate-180')} />
        {t('wizard.questions.scoringExamples')}
      </button>

      {open && (
        <div className="mt-2 flex flex-col gap-2 sm:grid sm:grid-cols-3">
          {[
            { label: t('wizard.questions.score1'), value: score1, color: 'text-destructive' },
            { label: t('wizard.questions.score3'), value: score3, color: 'text-muted-foreground' },
            { label: t('wizard.questions.score5'), value: score5, color: 'text-green-600' }
          ].map(({ label, value, color }) => (
            <div key={label} className="flex flex-col gap-0.5 sm:gap-1">
              <p className={cn('text-xs font-medium', color)}>{label}</p>
              <p className="text-xs text-foreground">{value}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
